import { useState } from "react";
import { Copy, Check } from "lucide-react";

const ReferralLinkCard = ({ referralCode }) => {
  const [copied, setCopied] = useState(false);
  const link = `https://ingroove.co.za/referrals?ref=${referralCode}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-bg-surface border border-border rounded-2xl p-6 card-hover">
      <p className="text-text-muted text-xs uppercase tracking-wider mb-3">
        Your referral link
      </p>
      <div className="flex items-center gap-3">
        <code className="flex-1 bg-bg-base border border-border rounded-xl px-4 py-2.5 text-text-secondary text-sm truncate">
          {link}
        </code>
        <button
          onClick={handleCopy}
          className="flex items-center gap-2 ingroove-gradient-bg text-white font-semibold text-sm px-4 py-2.5 rounded-xl hover:opacity-90 transition shadow-glow shrink-0"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
};

export default ReferralLinkCard;
